// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"DL-z","categoryName":"EL-z","categoryNameSearchHeader":"FL-z","categoryContent":"GL-z","bottomAligned":"HL-z","image":"IL-z","imageNoBackground":"JL-z"};